'use strict';
const PROVIDER_NAME = 'microsoft',
	MICROSOFT_TEAMS_IDENTITY = 'microsoft-teams',
	MICROSOFT_TEAM_SCOPES = ['Team.ReadBasic.All'],
	observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function MicrosoftTeamsIdentityProvider(params) {
	let currentPromise,
		currentResolve,
		currentReject,
		currentProviderProfile,
		currentOptions;

	const self = observable(this),
		{microsoftOAuthApi} = params,
		cleanUp = () => {
			currentPromise = false;
			currentResolve = false;
			currentResolve = false;
			currentReject = false;
			currentOptions = false;
			currentProviderProfile = false;
			self.dispatchEvent('popup-auth-close');
		},
		knownTeamIdentities = [],
		skippedTeamIdentities = [],
		processOAuthResult = result => {
			knownTeamIdentities.push(currentProviderProfile.id);
			currentResolve({
				provider: MICROSOFT_TEAMS_IDENTITY,
				token: result.token
			});
			cleanUp();
		},
		processOAuthFail = reason => {
			if (reason === 'popup-auth-required') {
				if (currentOptions && currentOptions.popupAuthEvent) {
					self.dispatchEvent(currentOptions.popupAuthEvent);
				} else {
					self.dispatchEvent(reason);
				}

				return;
			}
			currentReject(reason);
			cleanUp();
		};

	self.supports = provider => provider === PROVIDER_NAME;

	self.getTeamIdentity = async (providerProfile, callOptions) => {
		if (!providerProfile) {
			throw new Error('invalid-args');
		}
		if (skippedTeamIdentities.includes(providerProfile.id)) {
			return false;
		}
		if (knownTeamIdentities.includes(providerProfile.id)) {
			return {
				provider: MICROSOFT_TEAMS_IDENTITY,
				token: providerProfile.token
			};
		}
		if (currentPromise) {
			return currentPromise;
		}
		const returnPromise = currentPromise = new Promise((resolve, reject) => {
			currentResolve = resolve;
			currentReject = reject;
		});
		currentProviderProfile = providerProfile;
		currentOptions = callOptions;
		microsoftOAuthApi.headlessAuth({login_hint: currentProviderProfile.email, additionalScopes: MICROSOFT_TEAM_SCOPES})
		.then(processOAuthResult)
		.catch(processOAuthFail);
		return returnPromise;

	};
	self.dialogAuthForTeamIdentity = () => {
		return microsoftOAuthApi.dialogAuth({login_hint: currentProviderProfile.email, additionalScopes: MICROSOFT_TEAM_SCOPES})
		.then(processOAuthResult)
		.catch(processOAuthFail);
	};
	self.cancel = () => {
		if (currentResolve) {
			if (!currentOptions || !currentOptions.disableSkipping) {
				skippedTeamIdentities.push(currentProviderProfile.id);
			}
			currentResolve();
		}
		cleanUp();
	};
};
